import React from 'react';
import { Chip } from '@mui/material';

interface GreenChipProps {
  label: string;
  variant?: 'filled' | 'outlined';
  size?: 'small' | 'medium';
}

const GreenChip: React.FC<GreenChipProps> = ({
  label,
  variant = 'outlined',
  size = 'small'
}) => {
  return (
    <Chip
      label={label}
      color="success"
      variant={variant}
      size={size}
    />
  );
};

export default GreenChip;